var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiselogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 77,
    viewBox: "0 0 181 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1205_6117)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2703 30.5563C92.2959 29.789 96.4846 22.5308 96.4846 15.6211C96.4846 8.011 92.2255 0.404297 81.6867 0.404297H70.032L63.3301 6.9655H81.6163C86.3077 6.9655 89.2967 10.5946 89.2967 15.6211C89.2967 20.7145 86.5724 24.2733 79.9442 24.2733H63.3301V48.4941L70.5213 48.3031V30.5429H75.9632L88.3183 48.4807H96.9034L84.2703 30.5563Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.801 48.4946H109.641V15.8997H102.801V48.4946ZM106.223 0.307617C103.709 0.307617 101.531 2.19086 101.531 4.70409C101.531 7.21732 103.696 9.10056 106.223 9.10056C108.806 9.10056 110.897 7.21732 110.897 4.70409C110.897 2.19086 108.796 0.307617 106.213 0.307617H106.223Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.189 29.7897L127.233 28.5901C125.222 28.1009 123.326 26.985 123.326 24.961C123.326 22.7259 125.279 20.8427 128.141 20.8427C130.584 20.8427 133.027 22.4478 133.027 24.8203H139.588C139.588 17.9809 133.583 15.0488 128 15.0488C121.231 15.0488 116.416 19.4453 116.416 24.7499C116.416 29.5652 119.207 32.7084 125.279 34.3136L129.676 35.3591C132.119 35.9187 133.864 37.0345 133.864 39.1993C133.864 41.6421 131.559 43.5254 127.793 43.5254C124.106 43.5254 121.788 41.2936 121.788 38.71H115.438C115.578 45.5494 121.788 49.3192 127.86 49.3192C134.561 49.3192 140.704 45.5494 140.704 39.3367C140.704 35.8617 139.169 31.5356 132.189 29.7897Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.04 32.0208C178.04 21.7635 171.003 15.0615 161.711 15.0615C152.418 15.0615 144.889 21.7635 144.889 32.0911C144.889 42.4188 152.288 49.3319 161.711 49.3319C167.92 49.3319 173.774 46.3998 176.646 40.9545L171.2 38.2335C169.388 41.2494 165.839 42.9785 161.989 42.9785C156.754 42.9785 152.844 40.2575 151.936 34.9529H177.899C177.973 33.9074 178.04 32.9456 178.04 32.0208ZM152.009 29.4405C152.985 23.9952 156.754 21.3982 161.778 21.3982C166.801 21.3982 170.49 24.3303 171.2 29.4405H152.009Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3939 8.76179V26.857C51.3939 29.2999 50.4221 31.6422 48.693 33.368L33.7712 48.3032V31.0927V17.1526H20.1562L2.61719 17.1694L17.5491 2.23745C19.2782 0.515053 21.6205 -0.450027 24.06 -0.443325H42.1553C47.2421 -0.456729 51.3805 3.65491 51.3939 8.74169C51.3939 8.74839 51.3939 8.75509 51.3939 8.76179Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2943 20.0452L30.9126 20.0352L30.9026 33.9718L19.9784 44.896V31.1637H6.17578L17.2943 20.0452Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5117 62.9338V66.8779H78.1882V68.2685H72.5117V72.8426H70.8965V61.5264H78.8818V62.9338H72.5117Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8672 68.5597C79.8672 66.0062 81.7605 64.1934 84.3307 64.1934C86.9009 64.1934 88.7774 66.0029 88.7774 68.5597C88.7774 71.1131 86.9009 72.9394 84.3307 72.9394C81.7605 72.9394 79.8672 71.1131 79.8672 68.5597ZM87.2092 68.5597C87.2092 66.7334 85.9794 65.5539 84.3307 65.5539C82.682 65.5539 81.4354 66.7334 81.4354 68.5597C81.4354 70.386 82.682 71.5823 84.3307 71.5823C85.9794 71.5823 87.2092 70.386 87.2092 68.5597Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5334 64.1934V65.6979C95.4027 65.6812 95.2921 65.6812 95.1782 65.6812C93.5127 65.6812 92.4773 66.6999 92.4773 68.5764V72.8456H90.9258V64.2771H92.4136V65.7147C92.9632 64.7128 94.0288 64.1934 95.5334 64.1934Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.127 61.5264H103.745V71.4385H109.871V72.8426H102.127V61.5264Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.104 69.0757H112.151C112.345 70.5803 113.559 71.5823 115.254 71.5823C116.256 71.5823 117.097 71.2438 117.727 70.5468L118.585 71.5487C117.808 72.4535 116.628 72.9394 115.207 72.9394C112.443 72.9394 110.6 71.1131 110.6 68.5597C110.6 66.023 112.426 64.1934 114.899 64.1934C117.372 64.1934 119.135 65.9727 119.135 68.6066C119.138 68.7373 119.121 68.9316 119.104 69.0757ZM112.154 67.9599H117.65C117.489 66.5223 116.407 65.5036 114.902 65.5036C113.414 65.5036 112.315 66.5055 112.154 67.9599Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.833 67.6687V72.8426H126.362V71.71C125.846 72.4874 124.891 72.9398 123.551 72.9398C121.611 72.9398 120.381 71.9044 120.381 70.4165C120.381 69.0426 121.269 67.91 123.826 67.91H126.282V67.6017C126.282 66.2915 125.521 65.5308 123.987 65.5308C122.968 65.5308 121.932 65.886 121.269 66.4523L120.622 65.2895C121.51 64.5791 122.79 64.1904 124.164 64.1904C126.51 64.1938 127.833 65.3264 127.833 67.6687ZM126.282 70.2255V69.0292H123.889C122.355 69.0292 121.916 69.6291 121.916 70.3562C121.916 71.2141 122.626 71.7469 123.806 71.7469C124.972 71.7435 125.893 71.2107 126.282 70.2255Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.319 64.1934V65.6979C135.188 65.6812 135.077 65.6812 134.963 65.6812C133.298 65.6812 132.262 66.6999 132.262 68.5764V72.8456H130.711V64.2771H132.199V65.7147C132.748 64.7128 133.814 64.1934 135.319 64.1934Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.358 67.9135V72.8461H143.806V68.0944C143.806 66.4123 142.965 65.5879 141.494 65.5879C139.846 65.5879 138.78 66.5731 138.78 68.4329V72.8461H137.229V64.2777H138.716V65.5712C139.346 64.6966 140.445 64.1973 141.806 64.1973C143.887 64.1939 145.358 65.3902 145.358 67.9135Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.963 61.6232C147.963 61.0569 148.415 60.6045 149.015 60.6045C149.612 60.6045 150.067 61.0401 150.067 61.5897C150.067 62.1727 149.632 62.6251 149.015 62.6251C148.415 62.6251 147.963 62.1895 147.963 61.6232ZM148.238 64.2738H149.789V72.8422H148.238V64.2738Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.878 67.9135V72.8461H159.326V68.0944C159.326 66.4123 158.485 65.5879 157.014 65.5879C155.365 65.5879 154.3 66.5731 154.3 68.4329V72.8461H152.748V64.2777H154.236V65.5712C154.866 64.6966 155.965 64.1973 157.325 64.1973C159.406 64.1939 160.878 65.3902 160.878 67.9135Z",
    fill: "#17CCBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1205_6117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -52,
    y: -105,
    width: 285,
    height: 285
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M233 -105H-52V180H233V-105Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1205_6117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.002 64.2738V71.6794C172.002 74.702 170.468 76.0759 167.556 76.0759C165.987 76.0759 164.402 75.6403 163.464 74.7992L164.208 73.6029C164.999 74.2831 166.245 74.7188 167.505 74.7188C169.526 74.7188 170.448 73.7805 170.448 71.8403V71.16C169.704 72.048 168.588 72.487 167.361 72.487C164.888 72.487 163.012 70.8048 163.012 68.3318C163.012 65.8588 164.888 64.1934 167.361 64.1934C168.638 64.1934 169.801 64.6625 170.531 65.6008V64.2738H172.002ZM170.481 68.3318C170.481 66.6664 169.251 65.5505 167.539 65.5505C165.81 65.5505 164.58 66.6664 164.58 68.3318C164.58 69.9805 165.81 71.1299 167.539 71.1299C169.251 71.1299 170.481 69.9805 170.481 68.3318Z",
    fill: "#17CCBA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_6117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 77,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiselogo);
export default __webpack_public_path__ + "static/media/riselogo.9b52213df27965e3282561a8ec8e8bc1.svg";
export { ForwardRef as ReactComponent };